import type { Status } from '../../../model/kartera-api-model'

export { errorMessage, formatCount, pageWindow } from '../../customers/common/customer-common'

export const INSURERS_PATH = '/aseguradoras'
export const NEW_INSURER_PATH = `${INSURERS_PATH}/nueva`

export const insurerPath = (id: number) => `${INSURERS_PATH}/${id}`

export const STATUS_OPTIONS: Array<{ value: Status; label: string; dot: string }> = [
    { value: 'activo', label: 'Activo', dot: 'bg-k-ok' },
    { value: 'inactivo', label: 'Inactivo', dot: 'bg-k-danger' },
]

export const isActive = (status?: string | null) => String(status || '').toLowerCase() === 'activo'

export interface FormMessage {
    type: 'error' | 'success'
    message: string
}

/** `state` de navegación para mostrar un aviso al volver a la lista. */
export interface InsurersLocationState {
    backUrl?: string
    flash?: string
}
